import {forwardRef, type FocusEvent} from "react";
import {FormLabel} from "./FormLabel";
import {RadioGroup} from "./RadioGroup";
import {Radio} from "./Radio";

interface OptionsFormProps {
    id: string;
    name: string;
    options: {label?: string; value?: string}[];
    value: string;
    onChange: (e: {target: {value: string}}) => void;
    onFocus?: (e: FocusEvent) => void;
    onBlur?: (e: FocusEvent) => void;
}

export const OptionsForm = forwardRef<HTMLLabelElement, OptionsFormProps>(
    ({id, name, options, value, onChange, onFocus, onBlur}, ref) => (
        <FormLabel
            value={name}
            ref={ref}
            onFocus={onFocus}
            onBlur={onBlur}
            data-pw="dg-options"
        >
            <RadioGroup
                id={id}
                value={value}
                onChange={(val) => onChange({target: {value: val}})}
                options={options.map((o) => o.value ?? "")}
            >
                {options.map((opt) => (
                    <Radio
                        key={opt.value ?? opt.label}
                        value={opt.value ?? ""}
                        name={opt.label ?? opt.value ?? ""}
                    />
                ))}
            </RadioGroup>
        </FormLabel>
    )
);

OptionsForm.displayName = "OptionsForm";
